import _ from 'lodash';
import { PatientForm } from 'requests/resources';

import { PatientFormQuestion, PatientFormStatus, PatientFormTemplateItem, UserBase } from '@lib/resources/types';
import { getRedirectConfig, setAnswer } from '@lib/services/patientFormsService';

import { TMessageWrapper } from '../../../containers/Messages/MessageWrapper';

/**
 * Update the flow with the latest response
 */
export const getLumaBotFlowUpdated = (
  currentUser: UserBase,
  flow: PatientForm,
  currentItem: PatientFormTemplateItem,
  message: Partial<TMessageWrapper>,
  nextItem?: PatientFormTemplateItem,
): PatientForm => {
  const metadata = message.metadata || {};
  const currentQuestions = flow.responses.pages[0].questions;
  const nextItemId = _.get(nextItem, 'id');
  const patientFormCompleted = flow.status === PatientFormStatus.Completed || !nextItem;
  return {
    ...flow,
    patient: currentUser.$isWidgetUser ? flow.patient : currentUser.id,
    status: patientFormCompleted ? PatientFormStatus.Completed : flow!.status,
    responses: {
      ...flow!.responses,
      pages: [
        {
          questions: setAnswer(
            currentQuestions,
            currentItem.id,
            metadata.answer || message.text || message,
            nextItemId,
            true,
          ),
        },
      ],
      currentItemId: (patientFormCompleted ? 'success' : nextItemId) as string,
      finalDisposition: patientFormCompleted ? getRedirectConfig(currentItem as PatientFormQuestion) : undefined,
    },
  };
};
